import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const SiteStatusWarningGlyph = /*#__PURE__*/createElement("g", {
  id: "site_status_warning",
  fill: "none",
  style: {
    transform: 'scale(2.5)'
  }
}, /*#__PURE__*/createElement("ellipse", {
  opacity: "0.2",
  cx: "16",
  cy: "16.3433",
  rx: "16",
  ry: "16.3433",
  fill: "#FE8A01"
}), /*#__PURE__*/createElement("ellipse", {
  cx: "16.0001",
  cy: "16.3436",
  rx: "12.6316",
  ry: "12.9026",
  fill: "white"
}), /*#__PURE__*/createElement("mask", {
  id: "mask0_361_400",
  style: {
    maskType: 'alpha'
  },
  maskUnits: "userSpaceOnUse",
  x: "6",
  y: "7",
  width: "20",
  height: "19"
}, /*#__PURE__*/createElement("ellipse", {
  cx: "16",
  cy: "16.3432",
  rx: "9.26316",
  ry: "9.46194",
  transform: "rotate(90 16 16.3432)",
  fill: "#1AC632"
})), /*#__PURE__*/createElement("g", {
  mask: "url(#mask0_361_400)"
}, /*#__PURE__*/createElement("rect", {
  x: "26.3433",
  y: "16.3433",
  width: "10",
  height: "21",
  transform: "rotate(90 26.3433 16.3433)",
  fill: "#F1C40F"
})));
const SiteStatusWarning = createSvg({
  name: 'site_status_warning',
  path: SiteStatusWarningGlyph
});

export default SiteStatusWarning;
export { SiteStatusWarningGlyph };
